export default __webpack_public_path__ + "static/media/(2).bc1e8c43.jpg";